import logo from './logo.svg';
import './App.css';
import { VictoryChart, VictoryAxis, VictoryLine, VictoryTooltip, VictoryZoomContainer, VictoryBrushContainer, createContainer } from 'victory';
import copyright from './copyright.png';
import React from 'react';
import _ from 'lodash';

const dataOne = [
  { x: new Date(1982, 1, 1), y: 125 },
  { x: new Date(1987, 1, 1), y: 257 },
  { x: new Date(1993, 1, 1), y: 345 },
  { x: new Date(1997, 1, 1), y: 515 },
  { x: new Date(2001, 1, 1), y: 132 },
  { x: new Date(2005, 1, 1), y: 305 },
  { x: new Date(2011, 1, 1), y: 270 },
  { x: new Date(2015, 1, 1), y: 470 }
]

const dataTwo = [
  { x: new Date(1982, 1, 1), y: 3 },
  { x: new Date(1987, 1, 1), y: 5 },
  { x: new Date(1993, 1, 1), y: 1 },
  { x: new Date(1997, 1, 1), y: 4 },
  { x: new Date(2001, 1, 1), y: 10 },
  { x: new Date(2005, 1, 1), y: 2 },
  { x: new Date(2011, 1, 1), y: 13 },
  { x: new Date(2015, 1, 1), y: 9 }
]

// const data = [
//   [{ x: 1, y: 1 }, { x: 2, y: 2 }, { x: 3, y: 3 }, { x: 4, y: 4 }],
//   [{ x: 1, y: 400 }, { x: 2, y: 350 }, { x: 3, y: 300 }, { x: 4, y: 250 }],
//   [{ x: 1, y: 75 }, { x: 2, y: 85 }, { x: 3, y: 95 }, { x: 4, y: 100 }]
// ];

const data = [
  dataOne,
  dataTwo
]


// find maxima for normalizing data
const maxima = data.map(
	(dataset) => Math.max(...dataset.map((d) => d.y))
);

const xOffsets = [50, 200, 350];
const tickPadding = [ 0, 0, -15 ];
const anchors = ["end", "end", "start"];
const colors = ["black", "red", "blue"];

const containerStyle = {
  // backgroundImage: "url('https://i.imgur.com/XVCnqWS.jpg')",
  backgroundImage: `url(${copyright})`,
  backgroundSize: 'cover'
  // backgroundColor: 'green'
}

const divStyle = {width: "1000px", height: "320px"}

const VictoryZoomVoronoiContainer = createContainer("zoom", "voronoi");

class App extends React.Component {

  constructor(props) {
    super();
    this.entireDomain = this.getEntireDomain(props);
    this.state = {
      zoomDomain: { x: this.entireDomain.x }
    };
  }

  handleZoom(domain) {
    this.setState({ zoomDomain: {x: domain['x']} });
  }

  getEntireDomain(props) {
    const { data } = props;
    return {
      x: [ data[0].x, _.last(data).x ]
    };
  }

  getData = () => {
  	const zoomedXDomain = this.state.zoomDomain.x;
    const { data, maxPoints } = this.props;
    console.log('getData', data, maxPoints);
  	const filtered = data.filter(
    	(d) => (d.x >= zoomedXDomain[0] && d.x <= zoomedXDomain[1]));
    
    console.log('getData filtered', filtered);

    // if (filtered.length > maxPoints ) {
    //   const k = Math.ceil(filtered.length / maxPoints);
    // 	return filtered.filter(
    //   	(d, i) => ((i % k) === 0)
    //   );
    // }
    return filtered;
  }

  render() {
    const data = this.getData()
    console.log('renderData', data);
    return (
      <div>
        <VictoryChart scale={{ x: "time" }}
          height={300}
          width={550}
          containerComponent={
            <VictoryZoomVoronoiContainer
              zoomDimension="x"
              zoomDomain={this.state.zoomDomain}
              onZoomDomainChange={this.handleZoom.bind(this)}
              style={containerStyle}
            />
          }
          >
            <VictoryLine
              style={{
                data: { stroke: "#d4d233" }
              }}
              labels={({ datum }) => `y: ${datum.y1.toFixed(2)}`}
              data={data}
              x='x'
              y='y1'
              labelComponent={<VictoryTooltip
                style={{ fontSize: "8px", fill: "black" }}
                pointerLength={0}
              />}
            />

            <VictoryAxis
              style={{
                axis: {stroke: "white"},
                axisLabel: {fontSize: 20, padding: 30},
                tickLabels: {fontSize: 15, padding: 5, fill: 'white',}
              }}
              fixLabelOverlap={true}
            />
            <VictoryAxis dependentAxis
              style={{
                axis: {stroke: "white"},
                axisLabel: {fontSize: 20, padding: 30},
                tickLabels: {fontSize: 15, padding: 5, fill: 'white',}
              }}
            />

          </VictoryChart>
          <VictoryChart
            // padding={{ top: 10, left: 10, right: 10, bottom: 40 }}
            padding={{top: 0, left: 50, right: 50, bottom: 30}}
            scale={{ x: "time" }}
            height={90}
            width={550}
            containerComponent={
              <VictoryBrushContainer
                brushDimension="x"
                brushDomain={this.state.zoomDomain}
                onBrushDomainChange={this.handleZoom.bind(this)}
                style={containerStyle}
                brushStyle={{stroke: "transparent", fill: "white", fillOpacity: 0.1}}              />
            }
          >
            <VictoryAxis
              // tickFormat={(x) => new Date(x).getFullYear()}
              style={{
                axis: {stroke: "white"},
                axisLabel: {fontSize: 20, padding: 30, color: "white"},
                tickLabels: {fontSize: 15, padding: 5, fill: 'white'}
              }}
              fixLabelOverlap={true}
            />
            <VictoryLine
              style={{
                data: { stroke: "#d62976" }
              }}
              data={this.props.data}
              x='x'
              y='y2'
            />
          </VictoryChart>
      </div>
    );
  }
}

export default App;
